
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    var mod = $parcel$modules[id];
    if (mod !== undefined) {
      return mod.exports;
    }
    var init = $parcel$inits[id];
    if (init !== undefined) {
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("02nRr", function(module, exports) {
$parcel$export(module.exports, "register", () => $0072b2502976b004$export$6503ec6e8aabbaf, (v) => $0072b2502976b004$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0072b2502976b004$export$f7ad0328861e2f03, (v) => $0072b2502976b004$export$f7ad0328861e2f03 = v);
var $0072b2502976b004$export$6503ec6e8aabbaf;
var $0072b2502976b004$export$f7ad0328861e2f03;
"use strict";
var $0072b2502976b004$var$mapping = new Map();
function $0072b2502976b004$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0072b2502976b004$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0072b2502976b004$var$resolve(id) {
    var resolved = $0072b2502976b004$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0072b2502976b004$export$6503ec6e8aabbaf = $0072b2502976b004$var$register;
$0072b2502976b004$export$f7ad0328861e2f03 = $0072b2502976b004$var$resolve;

});

parcelRegister("4WmbV", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $eEA8O = parcelRequire("eEA8O");


var $hArLp = parcelRequire("hArLp");


var $1ytiN = parcelRequire("1ytiN");


var $iJ9aA = parcelRequire("iJ9aA");


var $ki6F7 = parcelRequire("ki6F7");


var $k4Vdy = parcelRequire("k4Vdy");


var $iC1wS = parcelRequire("iC1wS");


var $lNKOh = parcelRequire("lNKOh");


var $bhvFb = parcelRequire("bhvFb");


var $5u7Ox = parcelRequire("5u7Ox");


var $kpYGL = parcelRequire("kpYGL");

var $3a454656eb0e87cd$export$d33a80488b9cab17 = /*#__PURE__*/ function(SectionMessageButtonConfig) {
    SectionMessageButtonConfig["DEFAULT"] = "default";
    SectionMessageButtonConfig["UPGRADE_ONLY"] = "upgradeOnly";
    SectionMessageButtonConfig["NONE"] = "none";
    return SectionMessageButtonConfig;
}({});
const $3a454656eb0e87cd$export$2e68cfab3dc25476 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(65);
    let footer;
    let grandfathered;
    let headerButton;
    let learnMoreLink;
    let onRequestUpgradeButtonClick;
    let onUpFlowOpen;
    let props;
    let secondaryLink;
    let source;
    let t1;
    let t2;
    let t3;
    let t4;
    let t5;
    let t6;
    let targetEdition;
    if ($[0] !== t0) {
        ({ canShowUpgradeButton: t1, buttonConfig: t2, upgradeEditionActionSubjectId: t3, grandfathered: grandfathered, source: source, onUpFlowOpen: onUpFlowOpen, secondaryLink: secondaryLink, targetEdition: targetEdition, learnMoreLink: learnMoreLink, footer: footer, headerButton: headerButton, showRequestUpgradeButton: t4, isLoadingRequestUpgradeButton: t5, onRequestUpgradeButtonClick: onRequestUpgradeButtonClick, requestUpgradeButtonIsLoading: t6, ...props } = t0);
        $[0] = t0;
        $[1] = footer;
        $[2] = grandfathered;
        $[3] = headerButton;
        $[4] = learnMoreLink;
        $[5] = onRequestUpgradeButtonClick;
        $[6] = onUpFlowOpen;
        $[7] = props;
        $[8] = secondaryLink;
        $[9] = source;
        $[10] = t1;
        $[11] = t2;
        $[12] = t3;
        $[13] = t4;
        $[14] = t5;
        $[15] = t6;
        $[16] = targetEdition;
    } else {
        footer = $[1];
        grandfathered = $[2];
        headerButton = $[3];
        learnMoreLink = $[4];
        onRequestUpgradeButtonClick = $[5];
        onUpFlowOpen = $[6];
        props = $[7];
        secondaryLink = $[8];
        source = $[9];
        t1 = $[10];
        t2 = $[11];
        t3 = $[12];
        t4 = $[13];
        t5 = $[14];
        t6 = $[15];
        targetEdition = $[16];
    }
    const canShowUpgradeButton = t1 === undefined ? true : t1;
    const buttonConfig = t2 === undefined ? "default" : t2;
    const upgradeEditionActionSubjectId = t3 === undefined ? "freeTryNow" : t3;
    const showRequestUpgradeButton = t4 === undefined ? false : t4;
    const isLoadingRequestUpgradeButton = t5 === undefined ? false : t5;
    const requestUpgradeButtonIsLoading = t6 === undefined ? false : t6;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $iC1wS.useEditionsAnalyticsContext)();
    const { isSiteAdmin: isSiteAdmin } = (0, $42omo.useContext)((0, $1ytiN.SPAViewContext));
    const t7 = Boolean(grandfathered);
    let t8;
    if ($[17] !== isSiteAdmin || $[18] !== t7) {
        t8 = {
            isSiteAdmin: isSiteAdmin,
            isGrandfathered: t7
        };
        $[17] = isSiteAdmin;
        $[18] = t7;
        $[19] = t8;
    } else t8 = $[19];
    const CTAAnalyticsAttributes = t8;
    let t9;
    if ($[20] !== CTAAnalyticsAttributes || $[21] !== source) {
        t9 = (actionSubjectId)=>({
                actionSubjectId: actionSubjectId,
                source: source,
                attributes: CTAAnalyticsAttributes
            });
        $[20] = CTAAnalyticsAttributes;
        $[21] = source;
        $[22] = t9;
    } else t9 = $[22];
    const generateCTAAnalyticsProps = t9;
    let t10;
    if ($[23] !== CTAAnalyticsAttributes || $[24] !== createAnalyticsEvent || $[25] !== source) {
        t10 = (clickEventActionSubjectId, linkMessage)=>{
            if (createAnalyticsEvent) createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "link",
                    actionSubjectId: clickEventActionSubjectId,
                    source: source,
                    attributes: {
                        ...CTAAnalyticsAttributes,
                        linkMessage: linkMessage
                    }
                }
            }).fire();
        };
        $[23] = CTAAnalyticsAttributes;
        $[24] = createAnalyticsEvent;
        $[25] = source;
        $[26] = t10;
    } else t10 = $[26];
    const triggerLinkClickAnalytics = t10;
    let t11;
    if ($[27] !== secondaryLink || $[28] !== triggerLinkClickAnalytics) {
        t11 = ()=>{
            const link = secondaryLink;
            if (link) {
                triggerLinkClickAnalytics(link.actionSubjectId, link.messageDescriptor.defaultMessage);
                if (typeof link.onClick === "function") link.onClick();
            }
        };
        $[27] = secondaryLink;
        $[28] = triggerLinkClickAnalytics;
        $[29] = t11;
    } else t11 = $[29];
    const handleSecondaryLinkClick = t11;
    let t12;
    let t13;
    if ($[30] !== CTAAnalyticsAttributes || $[31] !== createAnalyticsEvent || $[32] !== source) {
        t12 = ()=>{
            if (createAnalyticsEvent) createAnalyticsEvent({
                type: "sendScreenEvent",
                data: {
                    name: "changeEditionGatewayScreen",
                    attributes: {
                        ...CTAAnalyticsAttributes,
                        source: source
                    }
                }
            }).fire();
        };
        t13 = [
            createAnalyticsEvent,
            CTAAnalyticsAttributes,
            source
        ];
        $[30] = CTAAnalyticsAttributes;
        $[31] = createAnalyticsEvent;
        $[32] = source;
        $[33] = t12;
        $[34] = t13;
    } else {
        t12 = $[33];
        t13 = $[34];
    }
    (0, $42omo.useEffect)(t12, t13);
    let T0;
    let t14;
    if ($[35] !== buttonConfig || $[36] !== canShowUpgradeButton || $[37] !== generateCTAAnalyticsProps || $[38] !== handleSecondaryLinkClick || $[39] !== isLoadingRequestUpgradeButton || $[40] !== isSiteAdmin || $[41] !== learnMoreLink || $[42] !== onRequestUpgradeButtonClick || $[43] !== onUpFlowOpen || $[44] !== props || $[45] !== requestUpgradeButtonIsLoading || $[46] !== secondaryLink || $[47] !== showRequestUpgradeButton || $[48] !== source || $[49] !== targetEdition || $[50] !== upgradeEditionActionSubjectId) {
        const renderButtons = ()=>{
            if (isLoadingRequestUpgradeButton) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
                testId: "loading-end-user-request-upgrade-button-skeleton",
                width: "200px",
                height: "32px"
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lNKOh.ChangeEditionSectionMessageButtonsWrapper), {
                isSiteAdmin: isSiteAdmin,
                canShowUpgradeButton: canShowUpgradeButton,
                shouldShowLearnMore: !secondaryLink,
                showRequestUpgradeButton: showRequestUpgradeButton
            }, (t15)=>{
                const { showUpgradeTryNowButton: showUpgradeTryNowButton, showLearnMore: showLearnMore, learnMoreIsPrimaryCTA: learnMoreIsPrimaryCTA } = t15;
                let primary;
                const upgradeEditionButton = showUpgradeTryNowButton ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ki6F7.UpgradeEditionButton), {
                    analyticsProps: generateCTAAnalyticsProps(upgradeEditionActionSubjectId),
                    onUpFlowOpen: onUpFlowOpen,
                    targetEdition: targetEdition,
                    ...props
                }) : null;
                if (upgradeEditionButton) primary = upgradeEditionButton;
                else if (showRequestUpgradeButton) primary = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5u7Ox.EndUserRequestUpgradeButton), {
                    source: source,
                    onRequestUpgradeButtonClick: onRequestUpgradeButtonClick,
                    requestUpgradeButtonIsLoading: requestUpgradeButtonIsLoading
                });
                let secondaries;
                if (buttonConfig !== "upgradeOnly" || !isSiteAdmin) {
                    if (upgradeEditionButton && primary !== upgradeEditionButton) secondaries = [
                        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).cloneElement(upgradeEditionButton, {
                            appearance: "link"
                        })
                    ];
                    else secondaries = getSecondaries(showLearnMore, learnMoreIsPrimaryCTA);
                }
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, primary, secondaries);
            });
        };
        const getSecondaries = (showLearnMore_0, learnMoreIsPrimaryCTA_0)=>{
            const withIcon = Boolean(learnMoreLink?.icon);
            const learnMoreAppearance = withIcon || learnMoreIsPrimaryCTA_0 ? learnMoreLink?.appearance || "default" : "link";
            const learnMoreButton = showLearnMore_0 ? renderLearnMoreLink({
                appearance: learnMoreAppearance
            }) : null;
            const secondaryLinkComponent = secondaryLink ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
                key: "secondLink",
                appearance: secondaryLink.appearance || "default",
                href: secondaryLink.href ? secondaryLink.href : undefined,
                id: "secondaryLink",
                spacing: "default",
                target: secondaryLink.target || "_blank",
                onClick: handleSecondaryLinkClick,
                testId: (0, $k4Vdy.calculateTestId)({
                    source: source,
                    actionSubjectId: secondaryLink.actionSubjectId
                })
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), secondaryLink.messageDescriptor)) : null;
            return secondaryLink?.appearance === "primary" && learnMoreAppearance !== "primary" ? [
                secondaryLinkComponent,
                learnMoreButton
            ] : [
                learnMoreButton,
                secondaryLinkComponent
            ];
        };
        const renderLearnMoreLink = (t16)=>{
            const { children: children, ...learnMoreProps } = t16;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iJ9aA.LearnMoreButton), {
                key: "learnMore",
                analyticsProps: generateCTAAnalyticsProps(learnMoreLink?.actionSubjectId || "freeLearnMore"),
                appearance: learnMoreLink?.appearance || "default",
                onUpFlowOpen: onUpFlowOpen,
                targetEdition: targetEdition,
                inProductHelpId: learnMoreLink?.inProductHelpId,
                inProductHelpTopic: learnMoreLink?.inProductHelpTopic,
                href: learnMoreLink?.href,
                icon: learnMoreLink?.icon,
                ariaLabel: learnMoreLink?.ariaLabel,
                ...learnMoreProps,
                onClick: learnMoreLink?.onClick
            }, children !== undefined ? children : learnMoreLink?.messageDescriptor ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), learnMoreLink.messageDescriptor) : undefined);
        };
        T0 = (0, $bhvFb.EditionSectionMessage);
        t14 = buttonConfig !== "none" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hArLp.default), null, renderButtons()) : undefined;
        $[35] = buttonConfig;
        $[36] = canShowUpgradeButton;
        $[37] = generateCTAAnalyticsProps;
        $[38] = handleSecondaryLinkClick;
        $[39] = isLoadingRequestUpgradeButton;
        $[40] = isSiteAdmin;
        $[41] = learnMoreLink;
        $[42] = onRequestUpgradeButtonClick;
        $[43] = onUpFlowOpen;
        $[44] = props;
        $[45] = requestUpgradeButtonIsLoading;
        $[46] = secondaryLink;
        $[47] = showRequestUpgradeButton;
        $[48] = source;
        $[49] = targetEdition;
        $[50] = upgradeEditionActionSubjectId;
        $[51] = T0;
        $[52] = t14;
    } else {
        T0 = $[51];
        t14 = $[52];
    }
    let t15;
    if ($[53] !== footer || $[54] !== isSiteAdmin) {
        t15 = isSiteAdmin && footer ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, footer) : null;
        $[53] = footer;
        $[54] = isSiteAdmin;
        $[55] = t15;
    } else t15 = $[55];
    let t16;
    if ($[56] !== headerButton) {
        t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hArLp.default), null, headerButton);
        $[56] = headerButton;
        $[57] = t16;
    } else t16 = $[57];
    let t17;
    if ($[58] !== T0 || $[59] !== props || $[60] !== t14 || $[61] !== t15 || $[62] !== t16 || $[63] !== targetEdition) {
        t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            actions: t14,
            edition: targetEdition,
            footer: t15,
            headerButton: t16,
            ...props
        });
        $[58] = T0;
        $[59] = props;
        $[60] = t14;
        $[61] = t15;
        $[62] = t16;
        $[63] = targetEdition;
        $[64] = t17;
    } else t17 = $[64];
    return t17;
} : ({ canShowUpgradeButton: canShowUpgradeButton = true, buttonConfig: buttonConfig = "default", upgradeEditionActionSubjectId: upgradeEditionActionSubjectId = 'freeTryNow', grandfathered: grandfathered, source: source, onUpFlowOpen: onUpFlowOpen, secondaryLink: secondaryLink, targetEdition: targetEdition, learnMoreLink: learnMoreLink, footer: footer, headerButton: headerButton, showRequestUpgradeButton: showRequestUpgradeButton = false, isLoadingRequestUpgradeButton: isLoadingRequestUpgradeButton = false, onRequestUpgradeButtonClick: onRequestUpgradeButtonClick, requestUpgradeButtonIsLoading: requestUpgradeButtonIsLoading = false, ...props })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $iC1wS.useEditionsAnalyticsContext)();
    const { isSiteAdmin: isSiteAdmin } = (0, $42omo.useContext)((0, $1ytiN.SPAViewContext));
    const CTAAnalyticsAttributes = (0, $42omo.useMemo)(()=>{
        return {
            isSiteAdmin: isSiteAdmin,
            isGrandfathered: Boolean(grandfathered)
        };
    }, [
        grandfathered,
        isSiteAdmin
    ]);
    const generateCTAAnalyticsProps = (actionSubjectId)=>({
            actionSubjectId: actionSubjectId,
            source: source,
            attributes: CTAAnalyticsAttributes
        });
    const triggerLinkClickAnalytics = (clickEventActionSubjectId, linkMessage)=>{
        if (createAnalyticsEvent) createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'link',
                actionSubjectId: clickEventActionSubjectId,
                source: source,
                attributes: {
                    ...CTAAnalyticsAttributes,
                    linkMessage: linkMessage
                }
            }
        }).fire();
    };
    const handleSecondaryLinkClick = ()=>{
        const link = secondaryLink;
        if (link) {
            triggerLinkClickAnalytics(link.actionSubjectId, link.messageDescriptor.defaultMessage);
            if (typeof link.onClick === 'function') link.onClick();
        }
    };
    (0, $42omo.useEffect)(()=>{
        if (createAnalyticsEvent) createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'changeEditionGatewayScreen',
                attributes: {
                    ...CTAAnalyticsAttributes,
                    source: source
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        CTAAnalyticsAttributes,
        source
    ]);
    const renderButtons = ()=>{
        if (isLoadingRequestUpgradeButton) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
            testId: "loading-end-user-request-upgrade-button-skeleton",
            width: "200px",
            height: "32px"
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lNKOh.ChangeEditionSectionMessageButtonsWrapper), {
            isSiteAdmin: isSiteAdmin,
            canShowUpgradeButton: canShowUpgradeButton,
            shouldShowLearnMore: !secondaryLink,
            showRequestUpgradeButton: showRequestUpgradeButton
        }, ({ showUpgradeTryNowButton: showUpgradeTryNowButton, showLearnMore: showLearnMore, learnMoreIsPrimaryCTA: learnMoreIsPrimaryCTA })=>{
            //
            // primary
            //
            let primary;
            const upgradeEditionButton = showUpgradeTryNowButton ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ki6F7.UpgradeEditionButton), {
                analyticsProps: generateCTAAnalyticsProps(upgradeEditionActionSubjectId),
                onUpFlowOpen: onUpFlowOpen,
                targetEdition: targetEdition,
                ...props
            }) : null;
            if (upgradeEditionButton) primary = upgradeEditionButton;
            else if (showRequestUpgradeButton) primary = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5u7Ox.EndUserRequestUpgradeButton), {
                source: source,
                onRequestUpgradeButtonClick: onRequestUpgradeButtonClick,
                requestUpgradeButtonIsLoading: requestUpgradeButtonIsLoading
            });
            //
            // secondaries
            //
            let secondaries;
            if (buttonConfig !== "upgradeOnly" || !isSiteAdmin) {
                // If the 'Try it free/now' button is to be shown, but it is not the
                // primary CTA, then make sure its appearance is appropriate for a
                // secondary:
                if (upgradeEditionButton && primary !== upgradeEditionButton) secondaries = [
                    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).cloneElement(upgradeEditionButton, {
                        appearance: 'link'
                    })
                ];
                else secondaries = getSecondaries(showLearnMore, learnMoreIsPrimaryCTA);
            }
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, primary, secondaries);
        });
    };
    const getSecondaries = (showLearnMore_0, learnMoreIsPrimaryCTA_0)=>{
        const withIcon = Boolean(learnMoreLink?.icon);
        const learnMoreAppearance = withIcon || learnMoreIsPrimaryCTA_0 ? learnMoreLink?.appearance || 'default' : 'link';
        const learnMoreButton = showLearnMore_0 ? renderLearnMoreLink({
            appearance: learnMoreAppearance
        }) : null;
        const secondaryLinkComponent = secondaryLink ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
            key: "secondLink",
            appearance: secondaryLink.appearance || 'default',
            href: secondaryLink.href ? secondaryLink.href : undefined,
            id: "secondaryLink",
            spacing: "default",
            target: secondaryLink.target || '_blank',
            onClick: handleSecondaryLinkClick,
            testId: (0, $k4Vdy.calculateTestId)({
                source: source,
                actionSubjectId: secondaryLink.actionSubjectId
            })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), secondaryLink.messageDescriptor)) : null;
        return secondaryLink?.appearance === 'primary' && learnMoreAppearance !== 'primary' ? [
            secondaryLinkComponent,
            learnMoreButton
        ] : [
            learnMoreButton,
            secondaryLinkComponent
        ];
    };
    const renderLearnMoreLink = ({ children: children, ...learnMoreProps })=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iJ9aA.LearnMoreButton), {
            key: "learnMore",
            analyticsProps: generateCTAAnalyticsProps(learnMoreLink?.actionSubjectId || 'freeLearnMore'),
            appearance: learnMoreLink?.appearance || 'default',
            onUpFlowOpen: onUpFlowOpen,
            targetEdition: targetEdition,
            inProductHelpId: learnMoreLink?.inProductHelpId,
            inProductHelpTopic: learnMoreLink?.inProductHelpTopic,
            href: learnMoreLink?.href,
            icon: learnMoreLink?.icon,
            ariaLabel: learnMoreLink?.ariaLabel,
            ...learnMoreProps,
            onClick: learnMoreLink?.onClick
        }, children !== undefined ? children : learnMoreLink?.messageDescriptor ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), learnMoreLink.messageDescriptor) : undefined);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bhvFb.EditionSectionMessage), {
        actions: buttonConfig !== "none" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hArLp.default), null, renderButtons()) : undefined,
        edition: targetEdition,
        footer: isSiteAdmin && footer ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, footer) : null,
        headerButton: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hArLp.default), null, headerButton),
        ...props
    });
};
module.exports["SectionMessageButtonConfig"] = $3a454656eb0e87cd$export$d33a80488b9cab17;
module.exports["ChangeEditionSectionMessage"] = $3a454656eb0e87cd$export$2e68cfab3dc25476;

});

parcelRegister("lNKOh", function(module, exports) {
const $5ea77288491beecf$export$2321d4fb07b49d13 = ({ canShowUpgradeButton: canShowUpgradeButton, children: children, isSiteAdmin: isSiteAdmin, shouldShowLearnMore: shouldShowLearnMore = true, showRequestUpgradeButton: showRequestUpgradeButton })=>{
    let showUpgradeTryNowButton = false;
    let showLearnMore = true;
    let learnMoreIsPrimaryCTA = true;
    if (canShowUpgradeButton) {
        if (isSiteAdmin) showUpgradeTryNowButton = true;
        if (showUpgradeTryNowButton) {
            // NOTE: Don't show 'Learn More' CTA if it will appear in between the
            // Upgrade Edition button and a secondary feature link (like
            // "Remove this page's restrictions" button). In those cases, "Learn
            // More" CTA will be displayed at the end of the general text content,
            // outside of this component.
            showLearnMore = shouldShowLearnMore;
            learnMoreIsPrimaryCTA = false;
        }
    }
    if (showRequestUpgradeButton) // If an end user request upgrade button is present,
    // we don't show the learn more link if it's not specifically provided.
    showLearnMore = shouldShowLearnMore;
    return children({
        showUpgradeTryNowButton: showUpgradeTryNowButton,
        showLearnMore: showLearnMore,
        learnMoreIsPrimaryCTA: learnMoreIsPrimaryCTA
    });
};
module.exports["ChangeEditionSectionMessageButtonsWrapper"] = $5ea77288491beecf$export$2321d4fb07b49d13;

});

parcelRegister("5u7Ox", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $ccHMk = parcelRequire("ccHMk");


var $6xdDU = parcelRequire("6xdDU");


var $inPa6 = parcelRequire("inPa6");


var $4PPzL = parcelRequire("4PPzL");


var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");


var $TCbX7 = parcelRequire("TCbX7");


var $bZmiL = parcelRequire("bZmiL");

const $125b05aca1e71376$export$ccc7e3a47fa3a9b0 = ({ source: source, requestUpgradeButtonIsLoading: requestUpgradeButtonIsLoading = false, onRequestUpgradeButtonClick: onRequestUpgradeButtonClick })=>{
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const hasSentViewedEvent = (0, $42omo.useRef)(false);
    const [showModal, setShowModal] = (0, $42omo.useState)(false);
    const [isLoadingModal, setIsLoadingModal] = (0, $42omo.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const handleCloseModal = ()=>{
        setShowModal(false);
    };
    const handleOpenModal = ()=>{
        if (onRequestUpgradeButtonClick) // If onRequestUpgradeButtonClick is provided, call it let it handle the modal opening
        onRequestUpgradeButtonClick();
        else {
            setIsLoadingModal(true);
            setShowModal(true);
        }
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'endUserRequestUpgradeButton',
                source: source,
                attributes: {
                    ...(0, $bZmiL.editionAnalytics)(edition)
                }
            }
        }).fire();
    };
    (0, $42omo.useEffect)(()=>{
        if (hasSentViewedEvent.current) return;
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'viewed',
                actionSubject: 'button',
                actionSubjectId: 'endUserRequestUpgradeButton',
                source: source,
                attributes: {
                    ...(0, $bZmiL.editionAnalytics)(edition)
                }
            }
        }).fire();
        hasSentViewedEvent.current = true;
    }, [
        createAnalyticsEvent,
        edition,
        source
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: edition === (0, $d9tcB.ConfluenceEdition).STANDARD ? 'growth-luna' : 'growth-transmuters'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        testId: "experiment-confluence-enable-end-user-request.request-upgrade-button",
        onClick: handleOpenModal,
        appearance: "primary",
        isLoading: isLoadingModal || requestUpgradeButtonIsLoading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
        id: "experiment-confluence-enable-end-user-request.request-upgrade-button.label",
        defaultMessage: "Request to try"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6xdDU.default), null, showModal && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $TCbX7.EndUserRequestUpgradeModalEntrypoint), {
        source: source,
        handleCloseModal: handleCloseModal,
        setIsLoadingModal: setIsLoadingModal
    })));
};
module.exports["EndUserRequestUpgradeButton"] = $125b05aca1e71376$export$ccc7e3a47fa3a9b0;

});

parcelRegister("TCbX7", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $2d60c82434c5c2c8$export$8512e09daabbe9d7 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "i-AMj",
    name: "EndUserRequestUpgradeModalEntrypoint",
    loader: async ()=>(await (parcelRequire("lS5AQ"))).EndUserRequestUpgradeModal
});
module.exports["EndUserRequestUpgradeModalEntrypoint"] = $2d60c82434c5c2c8$export$8512e09daabbe9d7;

});

parcelRegister("lS5AQ", function(module, exports) {

let $fec2fad029641bc3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $fec2fad029641bc3$var$load("7j0mT"),
    $fec2fad029641bc3$var$load("69R9L"),
    $fec2fad029641bc3$var$load("6wr18"),
    $fec2fad029641bc3$var$load("9anPW"),
    $fec2fad029641bc3$var$load("50ame"),
    $fec2fad029641bc3$var$load("Wowvf"),
    $fec2fad029641bc3$var$load("ffEVr"),
    $fec2fad029641bc3$var$load("zSp86"),
    $fec2fad029641bc3$var$load("hhss7"),
    $fec2fad029641bc3$var$load("eRrWU")
]).then(()=>parcelRequire('4YFRT'));

});

parcelRegister("4mJKd", function(module, exports) {
"use strict";


let $32dcb3648bfd454e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("8tirZ")).shardUrl((parcelRequire("02nRr")).resolve(id), maxShards));
    };
module.exports = $32dcb3648bfd454e$var$load;

});

parcelRegister("8tirZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $62af5803f3d08114$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $62af5803f3d08114$var$getDomainShardIndex;
module.exports.shardUrl = $62af5803f3d08114$var$shardUrl;
module.exports.shardUrlUnchecked = $62af5803f3d08114$var$shardUrlUnchecked;
const $62af5803f3d08114$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $62af5803f3d08114$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $62af5803f3d08114$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $62af5803f3d08114$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $62af5803f3d08114$var$removeTrailingShard(subdomain) {
    if (!$62af5803f3d08114$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $62af5803f3d08114$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$62af5803f3d08114$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $62af5803f3d08114$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $62af5803f3d08114$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $62af5803f3d08114$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $62af5803f3d08114$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $62af5803f3d08114$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$62af5803f3d08114$var$globalKeyName]) return url;
    return $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards);
}
const $62af5803f3d08114$var$domainShardingKey = module.exports.domainShardingKey = $62af5803f3d08114$var$globalKeyName;

});

parcelRegister("bZmiL", function(module, exports) {

var $7L1H0 = parcelRequire("7L1H0");

const $ac662e4699f149b2$export$a6ecd874f477affc = (edition)=>({
        currentProductEdition: (0, $7L1H0.mapConfluenceEditionToSupportedCurrentEdition)(edition)
    });
module.exports["editionAnalytics"] = $ac662e4699f149b2$export$a6ecd874f477affc;

});

parcelRegister("7L1H0", function(module, exports) {

var $d9tcB = parcelRequire("d9tcB");

const $4f5583827653668a$var$supportedCurrentEditionsMap = {
    [(0, $d9tcB.ConfluenceEdition).FREE]: 'free',
    [(0, $d9tcB.ConfluenceEdition).STANDARD]: 'standard'
};
const $4f5583827653668a$var$isSupportedEdition = (edition)=>{
    return edition in $4f5583827653668a$var$supportedCurrentEditionsMap;
};
const $4f5583827653668a$export$b48897de0c2497d9 = (edition)=>{
    if (!edition || !$4f5583827653668a$var$isSupportedEdition(edition)) return undefined;
    return $4f5583827653668a$var$supportedCurrentEditionsMap[edition];
};
module.exports["mapConfluenceEditionToSupportedCurrentEdition"] = $4f5583827653668a$export$b48897de0c2497d9;

});

var $71569b52918ddb0b$exports = {};

(parcelRequire("02nRr")).register(new URL("", import.meta.url).toString(), JSON.parse("[\"cEqm7\",\"GlobalCreateContentPopoverMenu.a281db61.js\",\"eRrWU\",\"EndUserRequestUpgradeModal.36d2e627.js\",\"bGfxQ\",\"error-visual-dark.a52399eb.png\",\"djGcB\",\"error-visual-light.8a0abe86.png\",\"b71Lk\",\"project-avatar-cat.058f0f6d.svg\",\"awo0s\",\"telepointer-admin.a25fedb7.svg\",\"1nIbz\",\"telepointer-you.b2757941.svg\",\"8kpTd\",\"visual-dark.589bc948.png\",\"aPOi6\",\"visual-light.1c3bfa82.png\",\"hhss7\",\"vendors~editor_atlaskit_lg.34273c41.js\",\"zSp86\",\"MainButtons.f116a2e5.js\",\"ffEVr\",\"vendors~editor_icon.70cd94e7.js\",\"Wowvf\",\"vendors~editor_atlaskit_sm.5d15a823.js\",\"50ame\",\"EndUserRequestUpgradeModal.bf73e453.js\",\"9anPW\",\"ShareAndRestrictDialog.ee52f40d.js\",\"6wr18\",\"vendors~editor_icon.d35f9155.js\",\"69R9L\",\"blockSubscription.b7888a84.js\",\"7j0mT\",\"blockSubscription.runtime.8773f4dc.js\",\"7j0mT\",\"blockSubscription.runtime.8773f4dc.js\"]"));


$parcel$global.rlb("cEqm7")
//# sourceMappingURL=GlobalCreateContentPopoverMenu.a281db61.js.map
